import React from "react";
import {SeriesCharacterInfo} from "../../models/interfaces/series.interface.ts";
import SeriesCharacterBasicDetails from "./SeriesCharecterBasicDetails.tsx";
import SeriesCharacterExpendedDetails from "./SeriesCharecterExpendedDetails.tsx";
import {CharacterGender} from "../../models/types/charecterGender.ts";

interface SeriesCharacterProps {
  character: SeriesCharacterInfo;
  isOpen: boolean;
  onCharacterClick: (characterId: string) => void;
  characterIndex: number;
  deleteCharacter: (characterId: string) => void;
  editNameGenderAge: (characterId: string, value: string | CharacterGender, field: "name" | "gender" | "ageRange") => void;
  setOtherNames: (characterId: string, otherNames: string[]) => void;
}

const SeriesCharacter: React.FC<SeriesCharacterProps> = (
  {
    character,
    isOpen,
    onCharacterClick,
    characterIndex,
    deleteCharacter,
    editNameGenderAge,
    setOtherNames
  }: SeriesCharacterProps) => {


  return (
    <div
      className={`${isOpen && "border border-brandPurple-500 rounded-xl p-2"} ${characterIndex !== 0 ? "mt-4" : ""}`}
      key={character.characterId}>
      <SeriesCharacterBasicDetails
        character={character}
        isOpen={isOpen}
        onClick={onCharacterClick}
        onDelete={deleteCharacter}
      />
      <SeriesCharacterExpendedDetails
        isOpen={isOpen}
        character={character}
        editNameGenderAge={editNameGenderAge}
        setOtherNames={setOtherNames}
      />
    </div>
  )
}

export default SeriesCharacter;